// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:960px){.px-md-30[data-v-4ef1bb7c]{padding:0 25vw}}.border-grey[data-v-4ef1bb7c]{border:1px solid #b8b8b8;border-radius:4px!important}.rounded-sides .id-option:first-child .border[data-v-4ef1bb7c]{border-radius:0 4px 4px 0!important}.rounded-sides .id-option:last-child .border[data-v-4ef1bb7c]{border-radius:4px 0 0 4px!important}", ""]);
// Exports
module.exports = exports;
